<template>
    <div v-if="!!planningItem">
        <md-list class="md-triple-line">
            <div :key="index" v-for="(comment, index) in planningItem.comments">
                <md-list-item>
                    <div class="md-list-item-text">
                        <span>{{ comment.created_by_user.first_name + ' ' + comment.created_by_user.last_name }}</span>
                        <span style="color: rgba(0, 0, 0, 0.34); font-size: 11px"
                            ><hour-display :date-time="comment.creation_date" date-time-format="DD/MM/YYYY HH:mm:ss"
                        /></span>
                        <p>{{ comment.data.comment }}</p>
                    </div>
                </md-list-item>

                <md-divider></md-divider>
            </div>
        </md-list>

        <md-button @click="showCommentDialog()" class="md-dense md-raised md-primary">Add comment</md-button>

        <!-- Todo make this a reusable component => also used in quote comment-->
        <md-dialog :md-active.sync="showComment">
            <md-dialog-title>Comment</md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <label for="comment">Comment</label>
                    <md-textarea id="comment" name="comment" v-model="comment.data.comment"> </md-textarea>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelComment()" class="md-primary">Cancel</md-button>
                <md-button @click="addComment()" class="md-primary">Add comment</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import HourDisplay from '../../../components/utils/HourDisplay.vue';
import { toastr } from '@/resources/toastr';
import { IPlanningItemEntity, ICommentEntity, PlanningItemCommentApi } from '@phrospr/api-backend';

@Component({
    components: { HourDisplay },
})
export default class PlanningDetailCommentsView extends Vue {
    showComment: boolean = false;
    comment: ICommentEntity = {
        data: {
            comment: '',
            contacted_info: {},
        },
        comment_id: null,
        creation_date: null,
        created_by_user_id: null,
    };

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    public async addComment() {
        console.log(this.comment);
        if (this.comment.data.comment != '') {
            try {
                await PlanningItemCommentApi.addPlanningItemComment(this.planningItem.planning_item_id, this.comment);
                // await CommentApi.addPlanningItemComment(this.comment, this.planningItem.planning_item_id);
                await this.$store.dispatch('refreshPlanningItem');
                this.showComment = false;
                toastr.success('commentaar geregistreerd');
            } catch (e) {
                console.log(e);
                toastr.error('er ging iets mis in het registreren van de comment');
            }
        } else {
            toastr.error('commentaar is leeg');
        }
    }

    public showCommentDialog() {
        this.showComment = true;
    }

    public cancelComment() {
        this.showComment = false;
        this.comment.data.comment = '';
    }
}
</script>

<style scoped></style>
